<template lang="pug">
md-layout(md-column='', md-align='start')
  md-theme(md-name='brown-white')
    breadcrumbs(section='Reporting', :nav='nav')

  md-theme(md-name='blue')
    financial-summary-table
</template>

<script>
import FinancialSummaryTable from '../../shared-components/report/FinancialSummaryTable';
import Breadcrumbs from '../../shared-components/Breadcrumbs';

export default {
  components: {
    FinancialSummaryTable,
    Breadcrumbs
  },
  computed: {
    nav() {
      return [{ title: 'Financial Summary' }];
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/spa/reporting/FinancialSummary.vue